<template>
  <div class="d-cur_address">
    <!-- 地址相关的逻辑 -->
    <div v-if="!isH5">
      <el-floating
        :width="widthSelectAddress"
        :title="title"
        :visible.sync="selectAddressVisible"
        :close-on-click-modal="false"
        append-to-body
        custom-class="el-floating_d-reset d-cur_address"
      >
        <div slot="icon" class="floating-footer" @click.stop="closeAddress">
          <i class="el-floating__close el-icon" :class="elIcon"></i>
        </div>
        <div class="current-address" v-show="!isEdit">
          <div class="input-content">
            <el-input
              v-model="inputVal"
              :placeholder="$t('输入地址')"
              prefix-icon="el-input__icon icon-outline_search"
              :clearable="true"
              input-on-composing
            ></el-input>
          </div>
          <ItemList
            v-show="!isEdit"
            :loading="loading"
            :inputVal="inputVal"
            :poiList="poiList"
            :fillterAddressList="fillterAddressList"
            :currentAid="currentAid"
            :typeName="typeName"
            :SFNoAddress="SFNoAddress"
            @selectFoodAddress="selectFoodAddress"
            @editAddressAction="editAddressAction"
          ></ItemList>
        </div>
        <EditAddress
          v-show="isEdit"
          @delAddress="delAddress"
          @createAddress="createAddress"
          @clickCurrentType="clickCurrentType"
          @selectAddressPage="selectAddressPage"
          :isEdit="isEdit"
          :selectType="selectType"
          :loading="loading"
          :currentEditAddress="currentEditAddress"
          :currentEditDesc="currentEditDesc"
          :currentTypeIndex="currentTypeIndex"
          :buildingNameVal.sync="buildingNameVal"
          :houseNumberVal.sync="houseNumberVal"
          :aid="aid"
          :currentAid="currentAid"
          :addressType="addressType"
          :typeName="typeName"
          :SFNoAddress="SFNoAddress"
        ></EditAddress>
      </el-floating>
    </div>
    <div v-else class="h5-address-content">
      <IndexH5
        v-model="h5Visible"
        :inputVal.sync="inputVal"
        :title="$t('选择送餐地址')"
        @closeH5Dialog="closeH5Dialog"
      >
        <ItemList
          :inputVal="inputVal"
          :poiList="poiList"
          :fillterAddressList="fillterAddressList"
          :currentAid="currentAid"
          :h5Visible="h5Visible"
          :loading="loading"
          :SFNoAddress="SFNoAddress"
          @selectFoodAddress="selectFoodAddress"
          @editAddressAction="editAddressAction"
          @delAddress="delAddress"
        ></ItemList>
      </IndexH5>
      <IndexH5
        v-model="isEdit"
        :loading="loading"
        :showInput="false"
        :title="$t('选择送餐地址')"
        @closeH5Dialog="closeH5EditDialog"
      >
        <div class="h5-edit-address-detail">
          <div class="edit-content">
            <div class="edit-infos">
              <div class="infos-display_name" @click="goSelectAddressPage">
                <div class="two-ellipsis infos-display_name_style">{{ currentEditAddress }}</div>
                <i class="icon-outline_entrance" v-if="isShowRightIcon"></i>
              </div>
              <div class="infos-display_desc">{{ currentEditDesc }}</div>
              <!-- <div class="infos-detaile">{{ $t('补充详细地址信息') }}</div> -->
              <input type="text" readonly class="d-hide-input">
              <el-input
                class="el-input_d-reset_h5_in"
                v-model="buildingNameVal"
                :placeholder="$t('公司/公寓名称')"
                :clearable="true"
              ></el-input>
              <el-input
                class="el-input_d-reset_h5_in"
                v-model="houseNumberVal"
                :placeholder="$t('楼层/门牌号')"
                :clearable="true"
              ></el-input>
              <div class="infos-type">{{ $t('设为常用地点') }}</div>
              <div class="infos-type_text_content">
                <div
                  v-for="item in addressType"
                  :key="item.type"
                  class="infos-type_text"
                  :class="{
                    'infos-type_text_active': item.type == currentTypeIndex,
                  }"
                  @click="clickCurrentType(item.type)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div v-if="isBillLading" class="h5-bill-infos">
              <!-- <div class="infos-type">{{ $t('姓名') }}</div> -->
              <el-input
                v-model="firstName"
                :placeholder="$t('名字')"
                :clearable="true"
                class="el-input_d-reset_h5_in"
              ></el-input>
              <el-input
                v-model="lastName"
                :placeholder="$t('姓氏')"
                :clearable="true"
                class="el-input_d-reset_h5_in"
              ></el-input>
              <!-- <div class="infos-type">{{ $t('电话号码') }}</div> -->
              <div class="phone-class">
                <el-input
                  class="calling-style"
                  v-model="callingCode"
                  @input="changeCalling"
                  @blur="blurCalling"
                  
                /><el-input
                  :placeholder="$t('电话号码')"
                  v-model="phone"
                  :clearable="true"
                  class="el-input_d-reset_h5_in"
                  oninput="value=value.replace(/[^\d]/g,'')"
                >
                </el-input>
              </div>
              <div class="err-tips" v-if="isShowNoNumber">
                {{ $t('请输入电话号码') }}
              </div>
            </div>
          </div>
          <div class="edit-confim">
            <el-button @click="createAddressConfirm">{{
              $t('确认')
            }}</el-button>
          </div>
        </div>
      </IndexH5>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { getLocalStorage } from '@/utils/localStorage';
import addressMonitor from '@/utils/addressMonitor';
import ItemList from './itemList.vue';
import EditAddress from './editAddress.vue';
import IndexH5 from './indexH5.vue';
export default {
  name: 'CurAddress',
  components: {
    ItemList,
    EditAddress,
    IndexH5,
  },
  props: {
    typeName: {
      type: String,
      default: '', // billLading 代表提单页面的地址
      required: false,
    },
    deliverAddressInfos: {
      required: false,
    },
    SFNoAddress: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      userInfo: ({ common }) => common.userInfo,
      feed_rec_id: ({ feed }) => feed.recId,
      addressInfos: ({ address }) => address.addressInfos,
      poiList: ({ address }) => address.poiList,
      loading: ({ address }) => address.loading,
      deliveryAddress: ({ address }) => address.deliveryAddress,
      historyAddressList: ({ address }) => address.historyAddressList,
      lastPoi: ({ address }) => address.lastPoi,
      lastPoiAid: ({ address }) => address.lastPoiAid,
    }),
    isLogin() {
      return getLocalStorage('isLogin');
    },
    title() {
      return this.isEdit ? this.$t('收货地址') : this.$t('选择送餐地址');
    },
    elIcon() {
      if (!this.isBillLading) {
        if (this.isEdit) {
          return 'icon-linetype_back_iOS';
        } else {
          return 'icon-outline_close';
        }
      } else {
        if (!this.isEdit) {
          return 'icon-linetype_back_iOS';
        } else {
          return 'icon-outline_close';
        }
      }
    },
    poiDisplayName() {
      return this.lastPoi?.displayName || this.$t('地址');
    },
    widthSelectAddress() {
      return this.is_mobile ? '100vw' : '470px';
    },
    currentAid() {
      return (
        this.currentAiddData || this.lastPoiAid || this.deliveryAddress?.address?.aid || ''
      );
    },
    // 过滤后的地址接口
    fillterAddressList() {
      let addressArr = [];
      if (this.deliveryAddress?.address) {
        addressArr.push(this.deliveryAddress?.address);
      }
      if (this.historyAddressList?.length) {
        addressArr = [...addressArr, ...this.historyAddressList];
      }
      return this.unique(addressArr, 'aid');
    },
    isFeedPage() {
      if (this.$route && this.$route.path === '/feed') {
        return true;
      }
      return false;
    },
    isBillLading() {
      return this.typeName === 'billLading';
    },
    isShowRightIcon() {
      if (this.SFNoAddress) return false;
      return this.isBillLading
    }
  },
  data() {
    return {
      selectAddressVisible: false, // 显示PC的弹出层
      h5Visible: false, // 显示h5的弹出层
      inputVal: '', // 搜素地址的val
      currentAiddData: '', // 当前选择的地址的aid
      isEdit: false, // 是否显示编辑的弹层页面
      currentTypeIndex: 0, // 0：无，1：家，2：公司
      buildingNameVal: '', // 家的地址
      houseNumberVal: '', // 门牌号
      currentEditAddress: '', // 当前编辑的地址名称
      currentEditDesc: '', // 当前编辑的地址名称详情描述
      poi: {}, // 当前poi
      aid: '', // 删除地址使用
      isFirstShowTip: false, // 创建或者更新地址的时候，标识是否没有输入门牌号和地址给一次提示
      selectType: 'listPage', // 从什么地方进入到的编辑页面，历史地址页面或者搜索地址页面
      clickIndex: 0, // 当前点击的地址索引
      addressType: [
        {
          name: this.$t('家'),
          type: 1,
        },
        {
          name: this.$t('公司'),
          type: 2,
        },
      ],
      firstName: '', // 配送方式的firstName
      lastName: '', // 配送方式的lastName
      phone: '', // 配送方式的phone
      isShowNoNumber: false, // 没有输入电话号码时，给一个提示且不能提交
      callingCode: '', // 日本区号
    };
  },
  watch: {
    inputVal(newV) {
      if (!newV) {
        this.setLoading({ loading: false });
        this.delPoiList()
        return;
      }
      this.setLoading({ loading: true });
      this.addressTextsearch({ query: newV });
    },
    isEdit() {
      if (this.isBillLading) {
        this.firstName = this.userInfo?.firstName;
        this.lastName = this.userInfo?.lastName;
        this.phone = this.userInfo?.phone;
        this.callingCode = this.userInfo?.callingCode;
      }
    },
    selectAddressVisible(newV) {
      if (newV) this.inputVal = '';
    },
  },
  created() {
    // 获取poi
    this.getLastPoi();
  },
  methods: {
    ...mapActions('common', ['setUserInfo']),
    ...mapActions('address', [
      'addressTextsearch',
      'addressList',
      'addressCreate',
      'addressUpdate',
      'addressDelete',
      'setLoading',
      'setLastPoi',
      'getLastPoi',
      'delPoiList'
    ]),
    // 修改区号
    changeCalling() {
      // +号不能删除，其余能删除，只能输入数字
      if (this.callingCode.length < 0) {
        this.callingCode = '+';
      } else {
        this.callingCode = '+' + this.callingCode.replace(/[^\d]/g, '');
      }
    },
    // 如果失去焦点
    blurCalling() {
      if (this.callingCode === '+') {
        this.callingCode = this.userInfo?.callingCode;
      }
    },
    unique(arr, val) {
      const res = new Map();
      return arr.filter(item => !res.has(item[val]) && res.set(item[val], 1));
    },
    // 重置当前数据
    resetInitData() {
      this.selectAddressVisible = false; // 显示PC的弹出层
      this.h5Visible = false; // 显示h5的弹出层
      this.inputVal = '';
      this.currentAiddData = '';
      this.isEdit = false;
      this.currentTypeIndex = 0;
      this.buildingNameVal = ''; //
      this.houseNumberVal = ''; // 门牌号
      this.currentEditAddress = '';
      this.currentEditDesc = '';
      this.poi = {};
      this.aid = ''; // 删除地址使用
      this.isFirstShowTip = false;
    },
    // 选择地址列表page
    selectAddressPage() {
      this.isEdit = false;
      this.addressList({
        lastPoi: JSON.stringify(this.lastPoi),
        lastAid: this.lastPoiAid,
      });
    },
    // 打开地址弹出层
    openSelectAddress() {
      // 打开地址搜索弹出层
      if (!this.isBillLading) {
        if (!this.isH5) {
          this.selectAddressVisible = true;
        } else {
          this.h5Visible = true;
        }
        this.addressList({
          lastPoi: JSON.stringify(this.lastPoi),
          lastAid: this.lastPoiAid,
        });
      } else {
        if (!this.isH5) {
          this.selectAddressVisible = true;
        }
        this.watchDeliverAddress();
      }

      if (this.isFeedPage) {
        this.$trackEvent({
          eventId: 'sailing_c_x_homepage_address_ck',
          eventLabel: '首页地址栏点击',
          attrs: {
            rec_id: this.feed_rec_id,
          },
        });
      }
    },
    // 选择地址
    async selectFoodAddress(val) {
      // 将poi存到localstorage中
      if (this.isBillLading && !this.isH5) {
        // 提单页 点击的时候 去编辑
        this.isEdit = true;
        this.currentEditAddress = val?.poi?.displayName;
        this.currentEditDesc = val?.poi?.addressAll;
        this.buildingNameVal = val?.buildingName;
        this.houseNumberVal = val?.houseNumber;
        this.poi = val.poi;
        this.aid = val?.aid;
        this.currentTypeIndex = val.type;
      } else if (this.isBillLading && this.isH5) {
        this.h5Visible = false;
        this.isEdit = true;
        this.currentEditAddress = val?.poi?.displayName;
        this.currentEditDesc = val?.poi?.addressAll;
        this.buildingNameVal = val?.buildingName;
        this.houseNumberVal = val?.houseNumber;
        this.poi = val.poi;
        this.aid = val?.aid;
        this.currentTypeIndex = val.type;
      } else {
        this.setLastPoi({
          lastPoi: {
            ...val?.poi,
            aid: val?.aid ? val?.aid : ''
          },
          lastPoiAid: val?.aid ? val?.aid : '',
        });
        this.currentAiddData = val?.aid ? val?.aid : ''; // 选中的逻辑
        this.againRequestData();
        this.$emit('selectFoodAddress', val);
      }
    },
    // 地址选择完成，再一次请求数据
    async againRequestData() {
      this.resetInitData();
      this.getLastPoi();
    },
    // 编辑地址
    editAddressAction(type, addressInfos, index) {
      this.clickIndex = index;
      this.selectType = type;
      if (type === 'listPage') {
        this.currentEditAddress = addressInfos?.poi?.displayName;
        this.currentEditDesc = addressInfos?.poi?.addressAll;
        this.buildingNameVal = addressInfos?.buildingName;
        this.houseNumberVal = addressInfos?.houseNumber;
        this.poi = addressInfos.poi;
        this.aid = addressInfos?.aid;
        this.currentTypeIndex = addressInfos.type;
      } else if (type === 'textSearch') {
        this.currentEditAddress = addressInfos.displayName;
        this.currentEditDesc = addressInfos?.addressAll;
        this.buildingNameVal = '';
        this.houseNumberVal = '';
        this.currentTypeIndex = 0;
        this.poi = addressInfos;
        this.aid = '';
      }
      if (this.isLogin) {
        if (this.isBillLading) {
          this.h5Visible = false;
        }
        this.isEdit = true;
        this.$emit('editAddress', {
          type,
          addressInfos,
        });
      } else {
        this.setLastPoi({
          lastPoi: {
            ...this.poi,
            aid:this.aid,
          },
          lastPoiAid: this.aid,
        });
        this.againRequestData();
      }
    },
    // 关闭h5地址选择列表弹窗
    closeH5Dialog() {
      if (this.SFNoAddress) {
        this.inputVal = '';
        this.$emit('closeAddress')
        return
      }
    },
    // h5编辑地址关闭，打开地址列表
    closeH5EditDialog() {
      this.goSelectAddressPage('DeliveryAddress')
    },
    // 关闭地址弹出层
    closeAddress() {
      if (!this.isH5) {
        if (!this.isBillLading) {
          if (this.isEdit) {
            this.isEdit = false;
          } else {
            this.selectAddressVisible = false;
            this.inputVal = ''
          }
        } else {
          // 如果是store关闭弹窗，通知父级展示弹窗
          if (this.SFNoAddress) {
            // 如果是编辑页面，进入列表页，否则关闭当前页面
            if (this.isEdit) {
              this.selectAddressPage()
            } else {
              this.inputVal = '';
              this.selectAddressVisible = false
              this.$emit('closeAddress')
            }
            return 
          }
          if (this.isEdit) {
            this.selectAddressVisible = false;
          } else {
            this.isEdit = true;
          }
        }
      } else {
        // h5的关闭逻辑
      }
    },
    // 选择公司或者家
    clickCurrentType(typeIndex) {
      if (this.currentTypeIndex === typeIndex) {
        this.currentTypeIndex = 0;
        return;
      }
      this.currentTypeIndex = typeIndex;
    },
    // 删除地址
    delAddress(aid, index, item) {
      this.$trackEvent({
        eventId: 'sailing_c_x_deliverydetail_delete_ck',
        eventLabel: '地址列表页地址编辑删除按钮点击',
        attrs: {
          selected_result_poiid: item?.poiId || this.poi?.poiId,
          selected_result_aid: aid || this.aid,
          index: index || this.clickIndex,
        },
      });
      this.$rconfirm(this.$t('确定删除地址吗？'), '', {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        customClass:'el-message-box_d-reset',
        showCancelButton: true,
        showClose: false,
        center: true,
        callback: async action => {
          if (action === 'confirm') {
            this.$trackEvent({
              eventId: 'sailing_c_x_deliverydetail_delete_confirm_ck',
              eventLabel: '地址列表页地址删除确认按钮点击',
              attrs: {
                selected_result_poiid: item?.poiId || this.poi?.poiId,
                selected_result_aid: aid || this.aid,
                index: index || this.clickIndex,
              },
            });
            await this.addressDelete({
              aid: aid || this.aid,
            });
            await this.addressList({
              // lastPoi: JSON.stringify(this.lastPoi),
            });
            this.isEdit = false;
          }
        },
      });
    },
    // 创建或者更新地址
    createAddressConfirm() {
      this.$trackEvent({
        eventId: 'sailing_c_x_deliverydetail_compiler_ck',
        eventLabel: '地址列表页地址编辑按钮点击',
        attrs: {
          selected_result_poiid: this.poi?.poiId,
          selected_result_aid: this.aid,
          index: this.clickIndex,
        },
      });
      if (this.isBillLading && !this.phone) {
        // 如果是提单页面的编辑，没有手机号，
        this.isShowNoNumber = true;
        let deliverPosition = document.querySelector('.phone-class');
        // block 定位 end center start nearest
        deliverPosition.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
        return;
      }
      if (this.phone) this.isShowNoNumber = false;
      if (
        (!this.houseNumberVal || !this.buildingNameVal) &&
        !this.isFirstShowTip
      ) {
        this.$rconfirm(
          this.$t('添加大楼名称以及门牌号，可以帮助配送员更快找你的送餐位置'),
          this.$t('补充详细地址信息'),
          {
            customClass:'el-message-box_d-reset',
            confirmButtonText: this.$t('去添加'),
            cancelButtonText: this.$t('忽略'),
            showCancelButton: true,
            showClose: false,
            center: true,
            callback: async action => {
              if (action === 'confirm') {
                this.isFirstShowTip = true;
              } else if (action === 'cancel') {
                this.asbortBillSetUserInfo();
                this.createAddress();
              }
            },
          }
        );
        return;
      }
      this.asbortBillSetUserInfo();
      this.createAddress();
    },
    asbortBillSetUserInfo() {
      if (this.isBillLading) {
        if (this.isShowNoNumber) this.isShowNoNumber = false;
        this.setUserInfo({
          firstName: this.firstName,
          lastName: this.lastName,
          callingCode: this.callingCode,
          phone: this.phone,
        });
      }
    },
    // 创建地址
    async createAddress() {
      if (!this.aid) {
        await this.addressCreate({
          type: this.currentTypeIndex,
          houseNumber: this.houseNumberVal || '',
          buildingName: this.buildingNameVal || '',
          poi: JSON.stringify(this.poi),
        });
      } else if (this.aid) {
        await this.addressUpdate({
          aid: this.aid,
          type: this.currentTypeIndex,
          houseNumber: this.houseNumberVal || '',
          buildingName: this.buildingNameVal || '',
        });

        this.$trackEvent({
          eventId: 'sailing_c_x_address_edit_confirm_ck',
          eventLabel: '地址列表页地址编辑确认按钮点击',
          attrs: {
            selected_result_poiid: this.poi?.poiId,
            selected_result_aid: this.aid,
          },
        });
      }

      this.currentAiddData = ''; // 选中的逻辑
      // 存取lastPoiAid
      this.setLastPoi({
        lastPoi:{
           ...this.poi,
           aid:this.addressInfos?.aid || '',
        },
        lastPoiAid: this.addressInfos?.aid || '',
      });
      this.$emit('selectFoodAddress', this.poi);
      this.againRequestData();
    },
    // 配送地址选择的时候编辑地址列表页面
    goSelectAddressPage(originPage) {
      if (originPage !== 'DeliveryAddress') {
        // 如果是SF则不进入地址选择页面
        if (this.SFNoAddress) return;
      }
      if (!this.isBillLading) return;
      this.h5Visible = true;
      // this.isEdit = false;
      this.addressList({
        lastPoi: JSON.stringify(this.lastPoi),
        lastAid: this.lastPoiAid,
      });
    },
    // 配送方式地址逻辑弹出层处理
    watchDeliverAddress() {
      let address = this.deliverAddressInfos?.data?.address;
      // 当前有地址，显示编辑页面，回显数据
      // 没有地址的时候当前选择的地址作为poi
      if (!address) {
        address = {};
        addressMonitor.flush();
        address.poi = addressMonitor.get();
      }
      this.currentEditAddress = address?.poi?.displayName || '';
      this.currentEditDesc = address?.poi?.addressAll || '';
      this.buildingNameVal = address?.buildingName || '';
      this.houseNumberVal = address?.houseNumber || '';
      this.poi = address.poi;
      this.aid = address?.aid || '';
      this.currentTypeIndex = address.type || '';
      this.isEdit = true;
    },
  },
};
</script>

<style lang="scss">
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.d-cur_address {
    .el-floating__title{
      line-height: 26px;
    }
  .current-address {
    height: 100%;
    display: flex;
    flex-direction: column;

    .input-content {
      padding: 0 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 64px;
      // 搜索输入框样式重置
      .el-input {
        .el-input__prefix {
          font-size: 16px !important;
          left: 11.5px !important;
          z-index: 11;
          i {
            color: #666 !important;
          }
        }
        .el-input__suffix {
          font-size: 16px !important;
          right: 14px !important;
          border-color: none !important;
          .el-icon-circle-close:before {
            color: #ccc !important;
            content: '\EA05' !important;
            font-size: 16px !important;
            font-family: icon !important;
          }
        }
        .el-input__suffix:hover {
          .el-icon-circle-close:before {
            color: #999 !important;
          }
        }

        input {
          font-family: 'Aspira Light';
          border: none !important;
          background-color: #e3e3e6 !important;
          font-size: 14px !important;
          color: #000000 !important;
          font-weight: 400 !important;
          min-width: 257px !important;
          &::placeholder {
            color: #999 !important;
          }
        }
      }
      .el-input--prefix .el-input__inner {
        padding-left: 40px !important;
      }

      .el-input--suffix .el-input__inner {
        padding-right: 48px !important;
      }
      .el-input:hover {
        input {
          background-color: #f5f5f7 !important;
        }
      }
    }
  }
  .el-floating__body_shadow {
    height: 100%;
  }
  .h5-address-content {
    .delivery-address__content {
      background: #fff;
    }
    .current-address__content {
      padding-bottom: 20px;
    }
    .delivery-address {
      position: relative;
      .info-desc {
        white-space: inherit;
        color: #000000 !important;
        font-family: 'Aspira Light';
        font-weight: 200;
      }
    }
    .address-select {
      font-size: 12px;
      position: absolute;
      right: 0px;
      top: 20px;
    }
  }
  .floating-footer {
    .icon-linetype_back_iOS {
      // font-size: 30px !important;
    }
  }

  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media screen and (max-width: 768px) {
  .h5-edit-address-detail {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    .edit-infos {
      overflow-y: auto;
      padding: rem(36) rem(18) rem(40);
      background: #fff;
      border-radius: rem(12);
      // margin-bottom: rem(20);
      .infos-display_name {
          display: flex;
          justify-content: space-between;
          margin-bottom: rem(16);
          .icon-outline_entrance{
            font-size: rem(30);
            position: relative;
            top: rem(8);
          }
      }
      .infos-display_name_style{
        font-family: 'Aspira Medium';
        font-size: rem(36);
        color: #000000;
        font-weight: 500;
        line-height: rem(44);
      }
      .infos-display_desc {
        font-size: rem(28);
        line-height: rem(36);
        color: #666666;
        font-weight: 200;
        margin-bottom: rem(40);
        font-family: 'Aspira Light';
      }
      .infos-detaile {
        font-size: 14px;
        color: #000000;
        font-weight: 400;
        padding: 12px 0;
      }
      .el-input {
        margin-bottom: rem(40);
      }
      .infos-type {
        margin-top:rem(20) ;
        font-size: rem(28) !important;
        color: #000000 !important;
        margin-bottom: rem(20) !important;
        font-family: 'Aspira Light' !important;
        font-weight: 200 !important;
        padding: 0 !important;
      }

      .infos-type_text_content {
        display: flex;
      }
      .infos-type_text {
        display: flex;
        justify-content: center;
        align-items: center;
        height: rem(72);
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: rem(8);
        margin-right: rem(12);
        font-size: rem(28);
        color: #000000;
        text-align: center;
        font-weight: 200;
        font-family: 'Aspira Light';
        padding: 0 rem(28)
      }
      .infos-type_text_active {
        @include font-color();
        @include act-tag-bg-color();
        font-weight: 500;
        font-family: 'Aspira Medium';
      }
    }
    .edit-confim {
      padding: 0 rem(24);
      margin-bottom: rem(24);
      button {
        width: 100%;
        border-radius: rem(8)
      }
    }
    .edit-content {
      flex: 1;
      overflow: auto;
      padding: rem(24);
      .infos-type {
        font-size: 14px;
        color: #000000;
        padding: 12px 0;
        font-family: 'Aspira Medium';
        font-weight: 500;
      }
      .err-tips {
        padding-top: rem(10);
        font-family: 'Aspira Light';
        font-size: rem(12);
        color: #ff4e45;
        font-weight: 200;
      }
      .phone-class {
        display: flex;
        border: 1px solid #cccccc;
        border-radius: 4px;
        .el-input {
          margin-bottom: 0px !important;
        }
        .el-input .el-input__inner {
          border: none;
        }
        .calling-style {
          width: 80px;
          border-radius: 0;
          // background-color: rgba(0, 0, 0, 0.05);
          input {
            height: 100%;
             font-size: rem(36);
          }
        }
        .calling-style .el-input__inner {
          background-color: rgba(0, 0, 0, 0.05);
        }
      }
    }
    .h5-bill-infos {
      margin-top: rem(20);
      background: #ffffff;
      border-radius: rem(12);
      padding:  rem(40) rem(18);
      .el-input_d-reset_h5_in{
        margin-bottom: rem(40);
      }
      .phone-class{
          border: none;
          border-bottom: 1px solid #EBEBEB;
          border-radius: 0;
          height: rem(80);
          .calling-style{
            width: rem(108);
            height: rem(72);
            border-radius: rem(8);
            margin-right: rem(20);
            input {
              padding: 0;
              text-align: center;
            }
          }
      }
    }
    .edit-confim{
      height: rem(168);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 0;
      button {
        width: rem(702);
        height: rem(88);
      }
    }
  }

.d-cur_address {
     .address-content {
    height: rem(36);
    display: flex;
    align-items: center;
    .icon-outlined_adress {
      font-size: rem(36);
      margin-right: rem(16);
    }
    .icon-outlinedpickup {
      font-size: rem(28);
      margin-left: rem(10);
    }
  }
}
.d-cur_address .h5-address-content {
    .current-address__content {
      padding-bottom: 0;
    }}
}
</style>
